<template>
  <v-container no-gutters class="ma-0 px-0 pr-9" :style="`min-width:100vw; min-height:100vh; background-position:top center; background-size:initial; background-repeat: repeat; background-image:url('${require('../../assets/dark parchment background.jpg')};`">
    <v-card style="background-color:rgb(0,0,0,0); width:100%; margin-top:36px;margin-bottom:24px" elevation="0">
        <v-row no-gutters dense style="margin-top:-36px; margin-bottom:-12px; height:36px">
            <v-col style="width:125px; max-width:125px">
                <v-checkbox v-model="fromAP" label="From AP" hide-details></v-checkbox>
            </v-col>
            <v-col style="width:125px; max-width:125px">
                <v-checkbox v-model="massAddSpells" label="Mass Add" hide-details></v-checkbox>
            </v-col>
            <v-col style="width:125px; max-width:125px">
                <v-checkbox v-model="autoAddSpell" label="Auto Add" hide-details></v-checkbox>
            </v-col>
            <v-col>
                <v-text-field v-if="autoAddSpell" v-model="autoAddLevel" label="Level" hide-details type="number" max="9" min="0" style="width:48px"></v-text-field>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="4">
                <div style="position: relative;">
                    <v-text-field
                        v-model="searchSpell"
                        label="Enter Spell Name to Learn"
                        outlined
                        dense
                        :style="`background-color:antiquewhite`"
                        hide-details
                        @input="onSpellSearch"
                        autocomplete="off"
                        ref="searchField"
                    ></v-text-field>
                    <v-menu
                        v-model="showSuggestions"
                        :close-on-content-click="false"
                        offset-y
                        max-width="400"
                        min-width="400"
                        :activator="$refs.searchField"
                    >
                        <v-list v-if="spellSuggestions.length > 0">
                            <v-list-item
                                v-for="spell in spellSuggestions"
                                :key="spell.name"
                                @click="selectSpell(spell)"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>{{ spell.name }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <div v-if="newSpell.name" style="display: flex; align-items: center; justify-content: center; margin-top: 4px">
                        <draggable 
                            :list="[newSpell]"
                            :group="{ name: 'spells', pull: true, put: false }"
                            item-key="id"
                            style="display: flex;"
                        >
                            <div 
                                :style="`
                                    border-color: black;
                                    border-width: 2px;
                                    border-style: ridge;
                                    background-color: #FFECC9;
                                    min-height: 30px;
                                    font-size: 12px;
                                    text-align: center;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    padding: 4px 8px;
                                    cursor: move;
                                    white-space: nowrap;
                                    margin-right: 8px;
                                `"
                            >
                                <span :style="`color:black; font-weight: bold;`">
                                    {{ newSpell.name }}
                                </span>
                            </div>
                        </draggable>
                        <v-icon small class="ml-1" @click.stop="openSpellEditor(newSpell)" style="cursor: pointer;">mdi-pencil</v-icon>
                        <v-btn small color="error" @click="clearNewSpell" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-col>
            <v-col cols="1">
                <v-menu offset-y nudge-left="60">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="color:black; margin-left:16px"
                        >
                        <v-icon style="font-size:32px;">settings</v-icon>
                        </v-btn>
                    </template>
                    
                    <v-list>
                        <v-list-item @click="websiteRulesDoc = true">
                            <v-list-item-title>Website Guide</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="7">
                <v-tabs v-model="activeSpellSection" background-color="#654321" dark style="margin-top:-36px">
                    <v-tab v-for="(section, sectionIndex) in spellData.spellSections" :key="sectionIndex">
                        {{ section.name }}
                    </v-tab>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" @click="addSpellSection" style="align-self: center; margin-right:12px">+ Add Section</v-btn>
                </v-tabs>
                <v-tabs-items v-model="activeSpellSection" style="background-color:transparent; margin-top:-2px">
                    <v-tab-item v-for="(section, sectionIndex) in spellData.spellSections" :key="sectionIndex">
                        <v-card style="background-color:#FFECC9;" class="pa-1 mb-0">
                            <div class="d-flex align-center mb-3">
                                    <v-text-field
                                        v-model="section.name"
                                        label="Section Name"
                                        hide-details
                                        dense
                                        class="mr-3"
                                        style="max-width: 250px;"
                                    ></v-text-field>
                                    <v-checkbox small color="primary" style="margin-bottom:0px" v-model="section.isSpontaneous" @click="resetSpells()" hide-details label="Spontaneous"></v-checkbox>
                                    <v-spacer></v-spacer>
                                    <div cols="1" no-gutters dense class="pa-0" style="justify-content: right;">
                                        <v-btn small color="error" @click="removeSpellSection(sectionIndex)" v-if="spellData.spellSections.length > 1">
                                            Remove Section
                                        </v-btn>
                                    </div>  
                                </div>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-card>
    

    <v-tabs-items v-model="activeSpellSection" style="background-color:transparent">
        <v-tab-item v-for="(section, sectionIndex) in spellData.spellSections" :key="sectionIndex">
            <!-- Favorites Section -->
            <v-card style="background-color:#FFECC9; margin-bottom:16px;" class="pa-3">
                <div class="text-h6 mb-3 text-center">Known Spells</div>
                <v-row>
                    <v-col v-for="level in 10" :key="level" class="text-center">
                        <div class="text-subtitle-2 mb-2">{{ level-1 + getOrdinalSuffix(level-1) }}</div>
                        <v-list dense style="background-color:transparent">
                            <draggable 
                                :list="section.favorites[level-1]"
                                :group="{ name: 'spells', pull: true, put: true }"
                                item-key="id"
                            >
                                <v-list-item 
                                    v-for="spell in section.favorites[level-1]" 
                                    :key="spell.id"
                                    @click="handleSpellClick($event, spell, level-1, section.favorites[level-1], 'favorites')"
                                    :style="`
                                        border-color: black;
                                        border-width: 2px;
                                        border-style: ridge;
                                        margin-bottom: 2px;
                                        background-color: #FFECC9;
                                        min-height: 30px;
                                        font-size: 12px;
                                        text-align: center;
                                        justify-content: center;
                                    `"
                                >
                                    <span :style="`color:black; font-weight: bold;`">
                                        {{ spell.name }}
                                    </span>
                                </v-list-item>
                            </draggable>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card>

            <!-- Spell Level Overview for this section -->
            <v-card style="background-color:#FFECC9;" class="pa-3">
                <div class="text-h6 mb-3 text-center">Spell Level Overview</div>
                <v-row>
                    <v-col v-for="level in 10" :key="level" class="text-center mx-6">
                        <div class="text-subtitle-2">{{ level-1 + getOrdinalSuffix(level-1) }}</div>
                        <v-text-field
                            v-model="section.spellsKnown[level-1]"
                            label="Spells Known"
                            type="number"
                            hide-details
                            class="text-center"
                        ></v-text-field>
                        <v-text-field
                            v-model="section.spellsPerDay[level-1]"
                            label="Spells per Day"
                            type="number"
                            hide-details
                            class="text-center"
                        ></v-text-field>
                        <v-text-field
                            v-model="section.bonusSpells[level-1]"
                            label="Bonus Spells"
                            type="number"
                            hide-details
                            class="text-center"
                        ></v-text-field>
                        <v-text-field
                            v-model="section.spellDC[level-1]"
                            label="Spell DC"
                            type="number"
                            hide-details
                            class="text-center"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <!-- Conditional Modifiers & Specialty for this section -->
                <v-row class="mt-3">
                    <v-col cols="6">
                        <div class="text-subtitle-2 mb-1">Conditional</div>
                        <div class="text-caption mb-2">Modifiers</div>
                        <v-text-field
                            v-model="section.conditionalModifiers"
                            label="Conditional Modifiers"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <div class="text-subtitle-2 mb-1">Specialty</div>
                        <div class="text-caption mb-2">Schools/Domains/Bloodline</div>
                        <v-text-field
                            v-model="section.specialty"
                            label="Specialty"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <!-- Spells for this section -->
                <div class="mt-4" style="border: 2px ridge #654321; border-radius: 4px; padding: 16px; position: relative;">
                    <v-row>
                    <v-btn @click="spellMasteryDoc = true" small color="primary">Spell Mastery</v-btn>
                    <v-spacer></v-spacer>
                    <div class="text-h6 mb-3 text-center">Spells:</div>
                    <v-spacer></v-spacer>
                    <div style="right: 6px; top: 6px; position: absolute;">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    style="background-color: saddlebrown; color:antiquewhite;"
                                >
                                    Reset Spells
                                    <v-icon right small>mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="resetAllSpells()">
                                    <v-list-item-title>Reset All Spells</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="resetSpells()">
                                    <v-list-item-title>Reset Spell List</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    </v-row>
                    <v-row v-for="level in 10" :key="level" style="border-bottom: 1px solid #654321; padding: 8px 0; min-height: 40px; display: flex; align-items: center;">
                        <v-col cols="12">
                        
                            <v-row>
                                <v-col cols="6" class="text-left">
                                    {{ level-1 + getOrdinalSuffix(level-1) }} Spells: ({{parseInt(section.spellsPerDay[level-1])+parseInt(section.bonusSpells[level-1])-section.spellsCast[level-1]}}/{{parseInt(section.spellsPerDay[level-1])+parseInt(section.bonusSpells[level-1])}})
                                </v-col>
                                <v-col cols="6" class="text-left" v-if="!section.isSpontaneous && getLeftToPrepare(section, level-1) > 0">
                                    <div><b>Left To Prepare: {{getLeftToPrepare(section, level-1)}}/{{parseInt(section.spellsPerDay[level-1])+parseInt(section.bonusSpells[level-1])}}</b></div>
                                </v-col>
                                <v-col cols="6" class="text-left" v-if="section.isSpontaneous && parseInt(section.spellsKnown[level-1])-section.spells[level-1].length > 0">
                                    <div><b>Spells Left Known: {{parseInt(section.spellsKnown[level-1])-section.spells[level-1].length}}</b></div>
                                </v-col>
                             </v-row> 
                            
                            <!-- Spell Casting Tracker for Spontaneous Casters -->
                            <!-- <div v-if="section.isSpontaneous && section.spellsPerDay[level-1] > 0" class="mb-2" style="display: flex; align-items: center; gap: 4px;">
                                <span class="text-caption mr-2">Cast:</span>
                                <div style="display: flex; gap: 2px;">
                                    <div 
                                        v-for="castIndex in section.spellsPerDay[level-1]" 
                                        :key="castIndex"
                                        @click="toggleSpellCast(section, level-1, castIndex)"
                                        :style="`
                                            width: 16px;
                                            height: 16px;
                                            border-radius: 50%;
                                            border: 2px solid #654321;
                                            background-color: ${section.spellsCast[level-1] >= castIndex ? '#654321' : 'transparent'};
                                            cursor: pointer;
                                            transition: background-color 0.2s;
                                        `"
                                        :title="`Click to ${section.spellsCast[level-1] >= castIndex ? 'uncast' : 'cast'} spell ${castIndex} of ${section.spellsPerDay[level-1]}`"
                                    ></div>
                                </div>
                                <span class="text-caption ml-2">{{ section.spellsCast[level-1] || 0 }}/{{ section.spellsPerDay[level-1] }}</span>
                            </div> -->
                            
                            <div style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center;">
                                <draggable 
                                    :list="section.spells[level-1]"
                                    :group="{ name: 'spells', pull: true, put: true }"
                                    item-key="id"
                                    style="display: flex; flex-wrap: wrap; gap: 4px;"
                                >
                                    <div 
                                        v-for="spell in section.spells[level-1]" 
                                        :key="spell.id"
                                        @click="handleSpellClick($event, spell, level-1, section.spells[level-1], 'list')"
                                        :style="`
                                            border-color: black;
                                            border-width: 2px;
                                            border-style: ridge;
                                            background-color: #FFECC9;
                                            min-height: 30px;
                                            font-size: 12px;
                                            text-align: center;
                                            display: flex;
                                            flex-direction: column;
                                            justify-content: center;
                                            align-items: center;
                                            padding: 4px 8px;
                                            cursor: pointer;
                                            white-space: nowrap;
                                        `"
                                    >
                                        <span :style="`color:black; font-weight: bold;`">
                                            {{ spell.name }}
                                        </span>
                                        <!-- Prepared/Cast Circles -->
                                        <div v-if="spell.prepared >= 0 && (!section.isSpontaneous || spell.cast > 0)" style="display: flex; gap: 2px; margin-top: 2px; justify-content: center; flex-flow: row-reverse;">
                                            <div 
                                                v-for="circleIndex in spell.prepared" 
                                                :key="circleIndex"
                                                @click="toggleSpellCast(spell, circleIndex)"
                                                :style="`
                                                    width: 8px;
                                                    height: 8px;
                                                    border-radius: 50%;
                                                    border: 1px solid #654321;
                                                    background-color: ${spell.cast >= circleIndex ? 'transparent' : '#654321'};
                                                    cursor: pointer;
                                                    transition: background-color 0.2s;
                                                `"
                                                :title="`Click to ${spell.cast >= circleIndex ? 'uncast' : 'cast'} spell ${circleIndex} of ${spell.prepared}`"
                                            ></div>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-tab-item>
    </v-tabs-items>

    <!-- Spell Details Panel -->
    <v-card elevation="0" class="light firefoxScroll mt-2" :style="`top:-9px;overflow-y: auto; background-color:rgb(0,0,0,0); width:100%; height:100%;`">
        <spell-card
            class="mr-1 pt-2"
            :characterSheetOverride="true"
            :style="`min-height:300px; border-width:6px; border-style:ridge; border-color:black!important; height:100%;`"
            :item="focused"
            @edit-spell="openSpellEditor"
        ></spell-card>
    </v-card>

    <!-- Dialogs -->

    <v-dialog v-model="spellMasteryDoc" :content-class="`${isMozilla() ? 'firefoxScroll' : 'darkBar2'} nooverflow`">
      <v-card style="overflow: hidden; background-color:transparent;width:100%;min-height: 70vh;">
        <v-img :style="`background-image:url('${require('../../assets/Inventory_bar 2.png')};background-repeat: round;min-height: 70vh;`">
          <v-card-title class="headline brown darken-4" :style="`width: 100%; overflow:hidden; color:antiquewhite;justify-content: center;font-size:42px!important`" hide-details="auto">Spell Mastery Info
          <!-- <v-icon @click="copySpellRoll('universal')" style="position:absolute; right:16px; top:16px; color:antiquewhite" large>settings</v-icon> -->
          </v-card-title>
            <v-row no-gutters style="overflow-x:hidden;justify-content:center;overflow-y:scroll;max-height:80vh; padding-left:16px;padding-bottom:32px" class="darkBar2">
              <v-btn @click="spellRulesDoc = true" dark>Spell Rules</v-btn>
              <v-col v-for="spellType in ['universal','fire','acid','cold','electricity','positive','negative']" v-bind:key="spellType" class="py-2 mx-4 my-2" sm="2">
                <v-card :style="`background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center;color:white; overflow:hidden; height:100%;max-height:475px; width:100%; box-shadow: ${spellColor(spellType)} 0 0 25px;`">
                  <v-img eager :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; bottom:0px;width:100%;  pointer-events: none;`" cover></v-img>
                  <v-img eager :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; clip-path: inset(0px 0px 75% 0px);width:100%;  pointer-events: none;`" cover></v-img>
                  <v-card-title :style="`padding-top:24px;justify-content:center;`"><span :style="`color: ${spellColor(spellType)}; text-shadow: ${spellTitleColor(spellType)} 0 0 30px;font-size:32px`">{{capitalize(spellType)}}</span><v-icon @click="copySpellRoll(spellType)" style="position:absolute; right:16px; top:16px; color:antiquewhite" large>mdi-dice-d20</v-icon></v-card-title>                  
                  <v-divider color="antiquewhite"></v-divider>
                  <!-- <v-card-subtitle class="py-2" style="color:antiquewhite">
                    <v-row>
                      <v-col style="text-align:center">
                        Total Known: <br/>Lol Idk 
                      </v-col>
                      <v-col style="text-align:center">
                        Levels Known: <br/>Lol Idk
                      </v-col>
                    </v-row>
                    <v-row style="justify-content:center; font-size:22px;margin-bottom:6px">
                      Mastery:
                    </v-row>
                  </v-card-subtitle> -->
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-text style="color:antiquewhite">
                    <div style="text-align:center; margin-bottom:12px">
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Power:  
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">{{parseInt(character.spellTracker.spellPower[spellType].power) + (spellType == "universal" ? 0 : parseInt(character.spellTracker.spellPower.universal.power)) }} <span v-if="spellType != 'universal'">({{ parseInt(character.spellTracker.spellPower[spellType].power) }})</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="character.spellTracker.spellPower[spellType].power" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Critical Chance: <br/>
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">{{ parseInt(character.spellTracker.spellPower[spellType].criticalChance) + (spellType == "universal" ? 0 : parseInt(character.spellTracker.spellPower.universal.criticalChance)) }}% <span v-if="spellType != 'universal'">(+{{ parseInt(character.spellTracker.spellPower[spellType].criticalChance) }}%)</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="character.spellTracker.spellPower[spellType].criticalChance" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="align-items:baseline">
                        <v-col cols="6">
                          Spell Critical Damage: 
                        </v-col>
                        <v-col cols="3">
                          <span style="white-space: nowrap;">+{{ parseInt(character.spellTracker.spellPower[spellType].criticalDamage) + (spellType == "universal" ? 0 : parseInt(character.spellTracker.spellPower.universal.criticalDamage)) }}% <span v-if="spellType != 'universal'">(+{{ parseInt(character.spellTracker.spellPower[spellType].criticalDamage) }}%)</span></span>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field dark v-model="character.spellTracker.spellPower[spellType].criticalDamage" dense single-line style="max-width: 50px; margin-left: 4px; text-align-last:center;"></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- <v-row no-gutters style="text-align: center;max-width:360px;margin-bottom:6px">
                        <v-col v-for="level in spellType.levels.filter(level=>level.count > 0)" :key="level.level" cols="6" class="my-1">
                        level {{level.level}}: <span :style="`padding-right:6px;padding-left:6px;border-width: 0px 0px 2px 0px;;border-style: ridge;border-color: antiquewhite`"> {{level.count}} </span>
                        </v-col>
                    </v-row> -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>           
          </v-img>
      </v-card>
    </v-dialog>

    <v-dialog v-model="websiteRulesDoc" max-width="800">
        <v-card style="background-color:#FFECC9">
            <v-card-title class="headline">Website Details</v-card-title>
            <v-card-text style="color:black">
                <h3>Spell Lists:</h3>
                <ul>
                    <li>Type a spell name in the "Enter Spell Name to Learn" bar at the top</li>
                    <li>New spells appear at the top of your list and can be dragged to any section</li>
                    <li>Use the checkbox at the top right to mark whether you are a spontaneous caster or not</li>
                    <li>Use the "+ Add Section" button to create new spell lists for a different class or spellbook</li>
                </ul>
                <br/>
                <h3>Click Modifiers:</h3>
                <li><b>Normal Click:</b> Select a spell to view its details in the bottom section</li>
                <br/><h4>Prepared Casters:</h4>
                <ul>
                    <li><b>Ctrl + Click:</b> Remove the spell from your current list</li>
                    <li><b>Shift + Click:</b> Toggle the spell as prepared/unprepared (shows/hides the circle under the spell name)</li>
                    <li><b>Alt + Click:</b> </li>
                </ul>
                <br/>
                <b>Spontaneous Casters:</b>
                <ul>
                    <li></li>
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Spell Editor Modal -->
    <v-dialog v-model="spellEditorDialog" max-width="800">
        <v-card style="background-color:#FFECC9">
            <v-card-title class="headline">Edit Spell: {{ editingSpell.name }}</v-card-title>
            <v-card-text v-if="!editingSpell.fromAP" style="color:black;">
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.name"
                            label="Spell Name"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.level"
                            label="Spell Level"
                            type="number"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="text-subtitle-2 mb-2">Description</div>
                        <div 
                            ref="richTextEditor"
                            contenteditable="true"
                            class="rich-text-editor"
                            @input="updateFormattedText"
                            @blur="updateFormattedText"
                            @keydown="handleKeydown"
                        ></div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editingSpell.full_text"
                            label="Full Text"
                            rows="4"
                            hide-details
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-text v-else style="color:black;">
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.name"
                            label="Spell Name"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.level"
                            label="Spell Level"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.school"
                            label="School"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.castingTime"
                            label="Casting Time"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.range"
                            label="Range"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.area"
                            label="Area"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.effect"
                            label="Effect"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.targets"
                            label="Targets"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.duration"
                            label="Duration"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.savingThrow"
                            label="Saving Throw"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.spellResistance"
                            label="Spell Resistance"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="editingSpell.components"
                            label="Components"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="editingSpell.tags"
                            label="Tags (comma-separated)"
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editingSpell.longDesc"
                            label="Long Description"
                            rows="8"
                            hide-details
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="spellEditorDialog = false">Cancel</v-btn>
                <v-btn color="primary" @click="saveSpellChanges">Save Changes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {spells as actualSpells} from "../../play/daba/spells"
import {psionPowers} from "../../play/daba/psionicPowers.js"
import draggable from 'vuedraggable';
import spellCard from "./spellCard.vue"
import { createClient } from '@supabase/supabase-js';
export default {
  components: {
    draggable,
    spellCard,
  },
  props: {
    character: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
        spellDB: actualSpells.concat(psionPowers),
        websiteRulesDoc: false,
        spellMasteryDoc: false,
        focused: {},
        searchSpell: "",
        activeSpellSection: 0,
        autoAddSpell: false,
        massAddSpells: false,
        autoAddLevel: 0,
        fromAP: false,
        // Supabase client
        supabase: createClient(
            'https://kbjjqssxridfwtqjwquo.supabase.co',
            'sb_publishable_PspCtMt73rIksYz1s0DhJw_SoC43B_U'
        ),
        
        // Autocomplete data
        spellSuggestions: [],
        searchTimeout: null,
        loadingSpells: false,
        showSuggestions: false,
        newSpell: {},
        
        // Spell editor
        spellEditorDialog: false,
        editingSpell: {},
        
        // Keyboard state tracking for spell section navigation
        tabKeyPressed: false,
    };
  },
  mounted(){
    console.log(this.spellDB.filter(spell => spell.name === "Reality Revision"));
    window.addEventListener('contextmenu', function(ev) {
        ev.preventDefault();
        return false;
    }, false);
    
    // Add keyboard shortcuts for spell section navigation
    window.addEventListener('keydown', this.handleKeyboardShortcuts);
    window.addEventListener('keyup', this.handleKeyboardShortcuts);
  },
  
  beforeDestroy() {
    // Remove keyboard event listeners
    window.removeEventListener('keydown', this.handleKeyboardShortcuts);
    window.removeEventListener('keyup', this.handleKeyboardShortcuts);
  },
  computed: {
    spellData() {
        // Always use the current tracker object. CharacterManagement replaces
        // section objects when realtime/server state is applied, so caching
        // this object in data() leaves the template rendering a stale copy.
        return this.character.spellTracker;
    },
    currentSection() {
        return this.spellData.spellSections[this.activeSpellSection];
    },
  },
  methods: {    
    createSpellSection(name) {
        const section = {
            name: name,
            spellsKnown: {},
            spellDC: {},
            spellsPerDay: {},
            bonusSpells: {},
            conditionalModifiers: "",
            specialty: "",
            spells: {},
            spellsCast: {},
            favorites: {},
            isSpontaneous: false
        };

        // Initialize all levels
        for (let i = 0; i <= 9; i++) {
            section.spellsKnown[i] = 0;
            section.spellDC[i] = 10 + i;
            section.spellsPerDay[i] = 0;
            section.bonusSpells[i] = 0;
            section.spellsCast[i] = 0;
            section.spells[i] = [];
            section.favorites[i] = [];
        }

        return section;
    },
    
    getOrdinalSuffix(num) {
        if (num === 0) return "th";
        const j = num % 10;
        const k = num % 100;
        if (j === 1 && k !== 11) return "st";
        if (j === 2 && k !== 12) return "nd";
        if (j === 3 && k !== 13) return "rd";
        return "th";
    },

    getLeftToPrepare(section, level) {
        // Calculate total spells per day for this level
        const totalSpellsPerDay = parseInt(section.spellsPerDay[level]) + parseInt(section.bonusSpells[level]);
        
        // Sum up all prepared spells at this level
        let totalPrepared = 0;
        if (section.spells[level]) {
            section.spells[level].forEach(spell => {
                totalPrepared += spell.prepared || 0;
            });
        }
        
        // Return remaining spells to prepare
        return Math.max(0, totalSpellsPerDay - totalPrepared);
    },

    async onSpellSearch(query) {
        console.log('Search query:', query); // Debug log
        
        // Clear previous timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        
        // Don't search if query is too short
        if (!query || query.length < 2) {
            this.spellSuggestions = [];
            this.showSuggestions = false;
            return;
        }
        
        // Handle mass add functionality
        if (this.massAddSpells && query.includes('|')) {
            this.handleMassSpellAdd(query);
            return;
        }
        
        // Set loading state
        this.loadingSpells = true;

        if(this.fromAP) {
            this.spellSuggestions = this.spellDB.filter(spell => spell.name.toLowerCase().includes(query.toLowerCase())).slice(0, 30);
            this.showSuggestions = this.spellSuggestions.length > 0;
            this.loadingSpells = false;
        }else{
            // Debounce the search
            this.searchTimeout = setTimeout(async () => {
                try {
                    const { data, error } = await this.supabase
                        .from('spell_descs')
                        .select('name')
                        .ilike('name', `%${query.toLowerCase()}%`)
                        .limit(30)
                        .order('name');
                    
                    if (error) throw error;
                    
                    this.spellSuggestions = data || [];
                    this.showSuggestions = data && data.length > 0;
                } catch (error) {
                    console.error('Error searching spells:', error);
                    this.spellSuggestions = [];
                    this.showSuggestions = false;
                } finally {
                    this.loadingSpells = false;
                }
            }, 300); // 300ms debounce
        }
    },
    
    async selectSpell(spellName) {
        if(this.fromAP) {
            this.addSpellFromDatabase(spellName);
        }else{
            let spell = await this.supabase
                .from('spell_descs')
                .select('*')
                .ilike('name', spellName.name)
                .single();
            this.addSpellFromDatabase(spell.data);
            this.showSuggestions = false;
            this.spellSuggestions = [];
        }
    },
        
    addSpellFromDatabase(spellData) {
        // Create a spell object from database data
        spellData.id = Math.random();
        spellData.trueName = spellData.name;
        spellData.prepared = 0;
        spellData.cast = 0;

        if(this.fromAP) {
            spellData.fromAP = true;
            spellData.uiType = "spell";
        }else{
            spellData.fromAP = false;
        }

        if(this.autoAddSpell) {
            if(this.currentSection.isSpontaneous) {
                this.currentSection.spells[this.autoAddLevel].push(spellData);
            }else{
                this.currentSection.favorites[this.autoAddLevel].push(spellData);
            }
        }else{
            this.newSpell = spellData;
        }
        this.searchSpell = "";
        this.spellSuggestions = [];
    },
    
    async handleMassSpellAdd(query) {
        // Split the query by | to get individual spell names
        const spellNames = query.split('|').map(name => name.trim()).filter(name => name.length > 0);
        
        console.log('Mass adding spells:', spellNames);
        
        // Process each spell name
        for (const spellName of spellNames) {
            try {
                let spellData;
                
                if (this.fromAP) {
                    // Search in local spell database
                    const foundSpell = this.spellDB.find(spell => 
                        spell.name.toLowerCase() === spellName.toLowerCase()
                    );
                    if (foundSpell) {
                        spellData = foundSpell;
                    }
                } else {
                    // Search in Supabase database
                    const { data, error } = await this.supabase
                        .from('spell_descs')
                        .select('*')
                        .ilike('name', spellName)
                        .single();
                    
                    if (error) {
                        console.warn(`Spell not found: ${spellName}`, error);
                        continue;
                    }
                    spellData = data;
                }
                
                if (spellData) {
                    // Determine the appropriate level for this spell
                    const spellLevel = this.determineSpellLevel(spellData, this.currentSection.name);
                    
                    // Create spell object
                    const spell = {
                        ...spellData,
                        id: Math.random(),
                        trueName: spellData.name,
                        prepared: 0,
                        cast: 0,
                        fromAP: this.fromAP,
                        uiType: this.fromAP ? "spell" : undefined
                    };
                    
                    // Add to the appropriate level
                    if (this.currentSection.isSpontaneous) {
                        this.currentSection.spells[spellLevel].push(spell);
                    } else {
                        this.currentSection.favorites[spellLevel].push(spell);
                    }
                    
                    console.log(`Added ${spellName} to level ${spellLevel}`);
                } else {
                    console.warn(`Spell not found: ${spellName}`);
                }
            } catch (error) {
                console.error(`Error processing spell ${spellName}:`, error);
            }
        }
        
        // Clear the search field
        this.searchSpell = "";
        this.spellSuggestions = [];
    },
    
    determineSpellLevel(spellData, sectionName) {
        // Default to level 0 if no level information is found
        let determinedLevel = 0;
        
        // Check if the spell has level information in its text
        const levelText = spellData.level || spellData.full_text || '';
        
        // Also check for partial matches (e.g., "wizard" should match "sorcerer/wizard")
        const sectionNameLower = sectionName.toLowerCase();
        const partialMatches = [
            sectionNameLower,
            sectionNameLower.replace(/s$/, ''), // Remove trailing 's'
            sectionNameLower + 's' // Add trailing 's'
        ];
        
        for (const partialMatch of partialMatches) {
            const partialRegex = new RegExp(`\\b${partialMatch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s+(\\d+)`, 'i');
            const match = levelText.match(partialRegex);
            if (match) {
                determinedLevel = parseInt(match[1]);
                break;
            }
        }
        
        // If no specific match found, try to find any level number in the text
        if (determinedLevel === 0) {
            const anyLevelMatch = levelText.match(/\b(\d+)\b/);
            if (anyLevelMatch) {
                determinedLevel = parseInt(anyLevelMatch[1]);
            }
        }
        
        // Ensure level is within valid range (0-9)
        return Math.max(0, Math.min(9, determinedLevel));
    },
    
    clearNewSpell() {
        this.newSpell = {};
    },
    
    openSpellEditor(spell) {
        
        // Create a deep copy of the spell to edit
        this.editingSpell = JSON.parse(JSON.stringify(spell));
        
        // Ensure description_formatted exists
        if (!this.editingSpell.description_formatted) {
            this.editingSpell.description_formatted = this.editingSpell.full_text || '<p>Enter spell description here...</p>';
        }
        
        this.spellEditorDialog = true;
        
        // Wait for DOM to update, then set content and focus
        this.$nextTick(() => {
            if (this.$refs.richTextEditor) {
                const content = this.editingSpell.description_formatted || this.editingSpell.full_text || '<p>Enter spell description here...</p>';
                this.$refs.richTextEditor.innerHTML = content;
                this.$refs.richTextEditor.focus();
            }
        });
    },
    
    saveSpellChanges() {
        // Find the original spell in all possible locations and update it
        const originalSpell = this.findSpellInAllLists(this.editingSpell.id);
        if (originalSpell) {
            // Update all properties of the original spell
            Object.assign(originalSpell, this.editingSpell);
        }
        
        // Update the focused spell if it's the same one
        if (this.focused.id === this.editingSpell.id) {
            this.focused = this.editingSpell;
        }
        
        this.spellEditorDialog = false;
    },
    
    findSpellInAllLists(spellId) {
        // Search in all spell sections
        for (const section of this.spellData.spellSections) {
            // Search in favorites
            for (let level = 0; level <= 9; level++) {
                const spell = section.favorites[level]?.find(s => s.id === spellId);
                if (spell) return spell;
            }
            
            // Search in spells
            for (let level = 0; level <= 9; level++) {
                const spell = section.spells[level]?.find(s => s.id === spellId);
                if (spell) return spell;
            }
        }
        
        // Search in newSpell
        if (this.newSpell.id === spellId) {
            return this.newSpell;
        }
        
        return null;
    },
    
    updateFormattedText() {
        if (this.$refs.richTextEditor) {
            this.editingSpell.description_formatted = this.$refs.richTextEditor.innerHTML;
            // Also update full_text with the plain text content
            this.editingSpell.full_text = this.$refs.richTextEditor.textContent || this.$refs.richTextEditor.innerText;
        }
    },
    
    handleKeydown(event) {
        // Prevent default behavior for certain keys that might interfere
        if (event.key === 'Enter') {
            event.preventDefault();
            document.execCommand('insertParagraph', false, null);
        }
    },
    
    toggleSpellCast(spell, castIndex) {
        console.log(spell, castIndex);
        return;
        // If clicking on a filled circle, uncast spells up to that point
        // if (spell.cast >= castIndex) {
        //     spell.cast = castIndex - 1;
        // } else {
        //     // If clicking on an empty circle, cast spells up to that point
        //     spell.cast = castIndex;
        // }
        
        // // Ensure we don't go below 0 or above max prepared spells
        // spell.cast = Math.max(0, Math.min(spell.cast, spell.prepared));
    },
    
    handleSpellClick(event, spell, level, list, listName) {
        if(event.ctrlKey) {
            if(listName === "list") {
                if(this.currentSection.isSpontaneous) {
                    if(spell.prepared-1 < 0) {
                        let index = list.findIndex(listSpell => listSpell.id === spell.id);
                        list.splice(index, 1);
                        return;
                    }
                    spell.prepared -= 1;
                    spell.cast = spell.prepared;
                    this.currentSection.spellsCast[level] -= 1;
                }else{
                    spell.prepared -= 1;
                    if(spell.prepared <= 0) {
                        let index = list.findIndex(listSpell => listSpell.id === spell.id);
                        list.splice(index, 1);
                    }
                }
                
            }else{
                // Remove spell from favorites list
                let index = list.findIndex(listSpell => listSpell.id === spell.id);
                if (index !== -1) {
                    list.splice(index, 1);
                }
            }
        } else if(event.shiftKey) {
            if(listName === "favorites") {
                let index = this.currentSection.spells[level].findIndex(listSpell => listSpell.name === spell.name);
                if(index === -1) {
                    let spellCopy = JSON.parse(JSON.stringify(spell));
                    spellCopy.id = Math.random();
                    spellCopy.cast = 0;
                    if(this.currentSection.isSpontaneous) {
                        spellCopy.prepared = 0;
                    }else{
                        spellCopy.prepared = 1;
                    }
                    this.currentSection.spells[level].splice(this.currentSection.spells[level].length, 0, spellCopy);
                } else if(!this.currentSection.isSpontaneous) {
                    this.currentSection.spells[level][index].prepared += 1;
                    console.log(this.currentSection.spells[level]);
                }
            } else if(listName === "list") {
                if(this.currentSection.isSpontaneous) {
                    spell.prepared += 1;
                    spell.cast = spell.prepared;
                    this.currentSection.spellsCast[level] += 1;
                }else{
                    if(spell.cast+1 > spell.prepared) return;
                    this.currentSection.spellsCast[level] += 1;
                    spell.cast += 1;
                    
                }
            }
        } else if(event.altKey) {
            if(listName === "list") {
                if(!this.currentSection.isSpontaneous) {
                    this.currentSection.spellsCast[level] -= 1;
                    if(this.currentSection.spellsCast[level] < 0) this.currentSection.spellsCast[level] = 0;
                    spell.cast -= 1;
                    if(spell.cast < 0) spell.cast = 0;
                }
            }
        } else {
            this.focused = spell;
        }
    },
    
    addSpellSection() {
        const newSection = this.createSpellSection(`Spell Section ${this.spellData.spellSections.length + 1}`);
        this.spellData.spellSections.push(newSection);
        this.activeSpellSection = this.spellData.spellSections.length - 1;
    },
    
    removeSpellSection(sectionIndex) {
        this.spellData.spellSections.splice(sectionIndex, 1);
    },

    addSpellLikePower() {
        this.spellData.spellLikePowers.push({
            name: "New Power",
            uses: 0
        });
    },

    removeSpellLikePower(index) {
        this.spellData.spellLikePowers.splice(index, 1);
    },
    
    resetSpells(section = this.currentSection) {
        for(let i = 0; i <= 9; i++) {
            section.spellsCast[i] = 0;
            for(let j = 0; j < section.spells[i].length; j++) {
                section.spells[i][j].cast = 0;
                if(section.isSpontaneous) {
                    section.spells[i][j].prepared = 0;
                }
            }
        }
    },
    resetAllSpells() {
        this.spellData.spellSections.forEach(section => this.resetSpells(section));
    },

    handleKeyboardShortcuts(event) {
        // Handle Tab key state tracking for spell section navigation
        if (event.type === 'keydown') {
            if (event.key === 'Tab') {
                this.tabKeyPressed = true;
                // Don't prevent default here - let normal Tab behavior work
            } else if (this.tabKeyPressed && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
                event.preventDefault();
                if (event.key === 'ArrowLeft') {
                    // Tab + Left Arrow = previous spell section
                    this.previousSpellSection();
                } else if (event.key === 'ArrowRight') {
                    // Tab + Right Arrow = next spell section
                    this.nextSpellSection();
                }
            }
        } else if (event.type === 'keyup') {
            if (event.key === 'Tab') {
                this.tabKeyPressed = false;
            }
        }
    },

    nextSpellSection() {
        // Spell section navigation
        if (this.activeSpellSection < this.spellData.spellSections.length - 1) {
            this.activeSpellSection++;
        } else {
            this.activeSpellSection = 0; // Loop back to first section
        }
    },

    previousSpellSection() {
        // Spell section navigation
        if (this.activeSpellSection > 0) {
            this.activeSpellSection--;
        } else {
            this.activeSpellSection = this.spellData.spellSections.length - 1; // Loop to last section
        }
    },
    copySpellRoll(spellType){
      let string = "!s damage," + (parseInt(this.character.spellTracker.spellPower[spellType].power) + (spellType == "universal" ? 0 : parseInt(this.character.spellTracker.spellPower.universal.power))) + "," + (parseInt(this.character.spellTracker.spellPower[spellType].criticalChance) + (spellType == "universal" ? 0 : parseInt(this.character.spellTracker.spellPower.universal.criticalChance))) + "," + (parseInt(this.character.spellTracker.spellPower[spellType].criticalDamage) + (spellType == "universal" ? 0 : parseInt(this.character.spellTracker.spellPower.universal.criticalDamage)))
      navigator.clipboard.writeText(string);
    },
    spellColor(spellType){
      let colorArr = {fire: "red", acid:"green", cold:"rgba(68, 179, 225, 255)", electricity:"yellow", positive:"white", negative:"rgb(36, 7, 51)", universal:"rgba(216, 109, 205, 255)"}
      if(colorArr[spellType]) return colorArr[spellType]
      else return "#000000"
    },
    spellTitleColor(spellType){
      if(spellType =="negative") return "rgba(255,255,255,1)"
      else return this.spellColor(spellType)
    },
    capitalize(str){
      for(let x = 0; x < str.length; x++){
        if(str[x].toUpperCase() == str[x]){
          str = str.substring(0,x) + " " + str.substring(x,str.length)
          break;
        }
      }            
      let newStr = str[0].toUpperCase() + str.substring(1)
      return newStr
    },
    isMozilla(){
      return navigator.userAgent.search("Firefox") > 1
    },
  }
}
</script>

<style scoped>
.rich-text-editor {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 12px;
  min-height: 200px;
  background-color: white;
  color: black;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  overflow-y: auto;
  outline: none;
}

.rich-text-editor:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

.rich-text-editor p {
  margin-bottom: 12px;
  text-align: justify;
}

.rich-text-editor p:last-child {
  margin-bottom: 0;
}

.rich-text-editor strong, .rich-text-editor b {
  font-weight: bold;
}

.rich-text-editor em, .rich-text-editor i {
  font-style: italic;
}

.rich-text-editor ul, .rich-text-editor ol {
  margin-bottom: 12px;
  padding-left: 20px;
}

.rich-text-editor li {
  margin-bottom: 4px;
}
</style>

<style scoped>
.draggable-notes {
  will-change: transform;
  cursor: move;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}
</style>